<template>
  <div class="ui small modal" ref="modal">
    <!--Mismo caso-->
    <i class="close icon" @click="$emit('close')"></i>
    <div class="content">
      <div class="ui form" ref="form">
        <h3
          class="ui dividing header fdinpro default-header-green is-uppercase"
        >
          {{ $t("bundle request") }}
        </h3>
        <div class="ui message" style="display: block">
          <div class="has-text-centered">
            {{ $t("if you dont have bundle assets download from ")
            }}<a :href="assets_url" target="_blank">{{ $t("here") }}</a>
          </div>
        </div>
        <div class="field">
          <label class="pt-05 fdinpro label-form is-capatilize">{{
            $t("store")
          }}</label>
          <div class="ui selection dropdown" ref="store_dropdown">
            <input type="hidden" name="store" />
            <i class="dropdown icon"></i>
            <div class="default text"></div>
            <div class="menu"></div>
          </div>
        </div>
        <div class="two fields">
          <div class="field">
            <label class="pt-05 fdinpro label-form">{{
              $t("upload web witness")
            }}</label>
            <!-- <input type="text" name="web_witness" placeholder="" v-model="d.web_witness" /> -->
            <file-pond
              name="file"
              ref="web_witness"
              :label-idle="$t('click or drop files here')"
              v-bind:allow-multiple="false"
              v-bind:allow-revert="false"
              v-bind:server="{
                url: api_host,
                timeout: enterprise_setup.upload_timeout,
                process: {
                  url: '/nvidia_ticket/store/do-upload-web-witness',
                  method: 'POST',
                  headers: {
                    'x-access-token': token_session,
                  },
                  withCredentials: false,
                },
              }"
              v-on:error="filepond_error_web"
              v-on:processfile="filepond_process_web"
            />
          </div>
          <div class="field">
            <label class="pt-05 fdinpro label-form">{{
              $t("upload social network witness")
            }}</label>
            <!-- <input type="text" name="social_witness" placeholder="" v-model="d.social_witness" /> -->
            <file-pond
              name="file"
              ref="social_witness"
              :label-idle="$t('click or drop files here')"
              v-bind:allow-multiple="false"
              v-bind:allow-revert="false"
              v-bind:server="{
                url: api_host,
                timeout: enterprise_setup.upload_timeout,
                process: {
                  url: '/nvidia_ticket/store/do-upload-social-witness',
                  method: 'POST',
                  headers: {
                    'x-access-token': token_session,
                  },
                  withCredentials: false,
                },
              }"
              v-on:error="filepond_error_social"
              v-on:processfile="filepond_process_social"
            />
          </div>
        </div>

        <div
          class="ui fluid button modal-button-green is-cap"
          tabindex="0"
          @click="request"
        >
          {{ $t("request approval") }}
        </div>
        <div class="ui error message"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { local_api, error_toast, enterprise_setup, api_host } from "@/utils";
import vueFilePond from "vue-filepond";
// Import FilePond styles
import "filepond/dist/filepond.min.css";

const FilePond = vueFilePond();

export default {
  components: {
    FilePond,
  },
  name: "",
  props: {},
  computed: {
    form() {
      let vm = this;
      return window.jQuery(vm.$refs.form).form({
        fields: {
          store: ["empty"],
          web_witness: ["empty"],
          social_witness: ["empty"],
        },
      });
    },
    token_session() {
      let token = this.$session.get("token");
      return token;
    },
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  data() {
    return {
      d: {
        web_witness: "",
        social_witness: "",
        store: "",
        bundle: "",
      },
      assets_url: "http://ellink.com",
      api_host: api_host,
      stores: [],
      bundle: {},
    };
  },
  methods: {
    request() {
      let vm = this;
      let isFormValid = true;
      isFormValid = vm.form.form("validate form");
      if (isFormValid) {
        local_api(vm, "post", "/nworkforce_store/do-request-bundle", {
          d: vm.d,
        })
          .then(function (r) {
            vm.$emit("request_created", r);
            window.jQuery(vm.$refs.modal).modal("hide");
          })
          .catch(function (err) {
            error_toast(err);
          });
      }
    },
    setStores(stores) {
      let vm = this;
      vm.stores = stores;
    },
    finished() {
      let vm = this;
      return new Promise(function (resolve, reject) {
        let isValid = vm.form.form("validate form");

        if (!isValid) reject();
        else {
          local_api(vm, "post", "/nworkforce_store/do-save", {
            i: vm.document ? vm.document.uuid : undefined,
            s: { files: vm.files },
          })
            .then((document) => {
              vm.$emit("succedded", document);
              console.log("hidden", vm.$refs.modal);
              window.jQuery(vm.$refs.modal).modal("hide");
              resolve();
            })
            .catch((err) => {
              reject(err);
            });
        }
      });
    },
    filepond_error_web(a, b) {
      console.log("error", a, b);
    },
    filepond_error_social(a, b) {
      console.log("error", a, b);
    },
    filepond_process_social(event, inst) {
      let vm = this;
      if (inst.serverId) {
        let r = JSON.parse(inst.serverId);
        if (!r.success) console.log(r.error);
        else {
          vm.d.social_witness = r.data;
        }
      }
    },
    filepond_process_web(event, inst) {
      let vm = this;
      if (inst.serverId) {
        let r = JSON.parse(inst.serverId);
        if (!r.success) console.log(r.error);
        else {
          vm.d.web_witness = r.data;
        }
      }
    },
    setBundle(bundle) {
      this.d.bundle = bundle.bundle_id;
      this.bundle = bundle;
      this.assets_url = bundle.setup.assets_link;
    },
    show() {
      let vm = this;
      window
        .jQuery(vm.$refs.modal)
        .modal({
          onVisible() {
            let vls = vm.stores.map((s) => {
              return { name: s.setup.name, value: s.store_id };
            });
            window
              .jQuery(vm.$refs.store_dropdown)
              .dropdown("setup menu", { values: vls })
              .dropdown({
                onChange(value) {
                  vm.d.store = value;
                },
              });

            setTimeout(() => {
              // console.log("vm.stores.length", vm.stores.length);
              if (vm.stores.length == 1) {
                vm.d.store = vm.stores[0].store_id;
                window
                  .jQuery(vm.$refs.store_dropdown)
                  .dropdown("set selected", vm.stores[0].store_id);
              }
            }, 500);
          },
          onHidden() {
            let x1 = vm.$refs.web_witness;
            x1.removeFiles().then(() => {});

            let x2 = vm.$refs.social_witness;
            x2.removeFiles().then(() => {});
          },
        })
        .modal("show");
    },
  },
};
</script>

<style scoped>
.py-2 {
  padding-top: 2rem !important;
  padding-bottom: 2rem !important;
}
.fdinpro {
  font-family: "DINPro" !important;
}
.default-header-green {
  border-bottom: 2pt solid #365a0c !important;
  font-weight: 300;
  font-size: 1.5rem !important;
}
.is-uppercase {
  text-transform: uppercase !important;
}
.is-capatilize {
  text-transform: capitalize !important;
}
/*  SIDE BAR BUTTONS    */
.pbundle {
  align-items: center !important;
}
.pbundle div button {
  border-radius: 2rem !important;
}
.pbundle div .cgray {
  font-weight: 700 !important;
}
.modal-button-green {
  background-color: #365a0c !important;
  color: white !important; /*width: 100%;*/
  font-family: "DINPro" !important;
  font-weight: 500;
}
.modal-button-green:hover {
  background-color: rgb(118, 185, 0) !important;
}
</style>
